export const DARK_MODE = 'DARK_MODE';
export const FILTERS = 'FILTERS';
// Search Types
export const SET_CLASSIFICATIONS = 'SET_CLASSIFICATIONS';
export const SET_INVESTORS = 'SET_INVESTORS';
export const SET_TERM = 'SET_TERM';
export const SET_DATE = 'SET_DATE';
export const SET_NAME = 'SET_NAME';
// User Types
export const ACCEPT_AGREEMENT = 'ACCEPT_AGREEMENT';
export const PIN_TRIGGER = 'SET_PIN_TRIGGER';
export const SET_PINS = 'SET_PINS';
// Impersonate Types
export const SET_IMPERSONATE_ID = 'SET_IMPERSONATE_ID';
export const SET_IMPERSONATE_NAME = 'SET_IMPERSONATE_NAME';
export const IMPERSONATE_ON = 'IMPERSONATE_ON';
export const IMPERSONATE_OFF = 'IMPERSONATE_OFF';
export const CAN_IMPERSONATE = 'CAN_IMPERSONATE';
// Modal Types
export const SWITCH_MODAL = 'SWITCH_MODAL';
export const SWITCH_CASH_FLOW_MODAL = 'SWITCH_CASH_FLOW_MODAL';
export const SWITCH_REDIRECTING_TO_DS_MODAL = 'SWITCH_REDIRECTING_TO_DS_MODAL';
export const SWITCH_MULTIPLE_DOWNLOAD_MODAL = 'SWITCH_MULTIPLE_DOWNLOAD_MODAL';
export const REACHED_LIMIT_MODAL = 'REACHED_LIMIT_MODAL';
export const CLOSE_REACHED_LIMIT_MODAL = 'CLOSE_REACHED_LIMIT_MODAL';
export const CLOSE_MULTIPLE_DOWNLOAD_MODAL = 'CLOSE_MULTIPLE_DOWNLOAD_MODAL';
// DocuSign Types
export const SWITCH_DOCUSIGN_DROPDOWN = 'SWITCH_DOCUSIGN_DROPDOWN';
export const CLOSE_DOCUSIGN_DROPDOWN = 'CLOSE_DOCUSIGN_DROPDOWN';
//Settings Types
export const SET_TOOLTIP = 'SET_TOOLTIP';
// Investor types
export const SET_INVESTOR = 'SET_INVESTOR';
// Investor types
export const SET_ACTIVE_BOARD = 'SET_ACTIVE_BOARD';
